import { humanizeCondition } from "../utils/humanizeCondition";

export default function ConditionPreview({ condition, places }) {
  return (
    <p className="muted">
      {humanizeCondition(condition, { places })}
    </p>
  );
}
